import { useEffect, useState } from "react";
import SPfetch from "../../../../../services/SPFetch.class";

const useSignUpTermsQuery = () => {
  const [signUpTermsText, setSignUpTermsText] = useState({
    text: "",
    errorText: "",
  });

  useEffect(() => {
    (async () => {
      const data = await SPfetch.get(
        `https://cdn.builder.io/api/v3/content/global-options?apiKey=${process.env.GATSBY_BUILDER_REBRAND_API_KEY}`
      );

      const { signUpTerms } = data.results[0].data;

      if (signUpTerms) {
        setSignUpTermsText({
          text: signUpTerms.termsAgreementText,
          errorText: signUpTerms.termsAgreementErrorText,
        });
      }
    })();
  }, []);

  return signUpTermsText;
};

export default useSignUpTermsQuery;
